import { useContext, useRef, useState } from 'react';
import { DialogContext } from "../../store/context/DialogContext";
import BusinessPRTNC from './BusinessPRTNC';
import BusinessPlusTNC from './BusinessPlusTNC';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../InputField/testId';

const TERMS_CONTENT = {
    BUSINESS_PR: BusinessPRTNC,
    BUSINESS_PLUS: BusinessPlusTNC,
};

export default function TermsAcknowledgement({
    id,
    onAccept,
    height = 250,
    isChecked,
    isDisabled = false,
    contentType,
    fullContent = false,
}) {
    const [canCheck, setCanCheck] = useState(isChecked ? true : false);
    const { showError } = useContext(DialogContext);
    const scrollerRef = useRef(null);
    const fieldTestId = resolveAutomationTestId(id, "terms-acknowledgement");

    const TermsContent = TERMS_CONTENT?.[contentType] || BusinessPlusTNC;

    const handleScroll = () => {
        const node = scrollerRef.current;
        if (!node) return;

        const reachedBottom =
            node.scrollTop + node.clientHeight >= node.scrollHeight - 4;

        if (reachedBottom && !canCheck) setCanCheck(true);
    };

    const handleChange = (e) => {
        if (isDisabled) {
            return;
        }
        if (!fullContent && !canCheck) {
            showError("Please read all information about procedures for opening an account, to enable the checkbox.");
            return;
        }
        const checked = e.target.checked;
        onAccept?.(checked);
    };

    const isInteractive = !isDisabled && (fullContent || canCheck);

    return (
        <div className="ta-wrapper" data-testid={fieldTestId}>
            {fullContent ? (
                <>
                    <div className="ta-content ta-content--full" data-testid={buildAutomationChildTestId(fieldTestId, "content")} tabIndex={isDisabled ? -1 : 0}>
                        <TermsContent />
                    </div>
                    <label
                        className={`ta-checkbox mb-0 ${isInteractive ? '' : 'ta-disabled'}`}
                        data-testid={buildAutomationChildTestId(fieldTestId, "label")}
                        aria-disabled={isDisabled}
                    >
                        <input
                            id={id}
                            data-testid={buildAutomationChildTestId(fieldTestId, "input")}
                            className='ta-checkbox-input'
                            type="checkbox"
                            checked={!!isChecked}
                            disabled={isDisabled}
                            onChange={handleChange}
                        />
                        <span>I acknowledge and agree to the following statements</span>
                    </label>
                </>
            ) : (
                <>
                    <label
                        className={`ta-checkbox mb-0 ${isInteractive ? '' : 'ta-disabled'}`}
                        data-testid={buildAutomationChildTestId(fieldTestId, "label")}
                        aria-disabled={isDisabled}
                    >
                        <input
                            id={id}
                            data-testid={buildAutomationChildTestId(fieldTestId, "input")}
                            className='ta-checkbox-input'
                            type="checkbox"
                            checked={!!isChecked}
                            disabled={isDisabled}
                            onChange={handleChange}
                        />
                        <span>I acknowledge and agree to the following statements</span>
                    </label>

                    <div
                        className="ta-content"
                        data-testid={buildAutomationChildTestId(fieldTestId, "content")}
                        ref={scrollerRef}
                        onScroll={handleScroll}
                        tabIndex={isDisabled ? -1 : 0}
                        style={{ height }}
                    >
                        <TermsContent />
                    </div>
                </>
            )}
        </div>
    );
}
